<template>

	<div>

        <!-- page-heading -->
        <page-heading :show="true" pageTitle="COMPLAT-NEWSLETTERS-TITLE"></page-heading>

        <div class="columns">

            <div class="col-main">

				<!-- NEWSLETTERS -->
				<tabs :active-index="activeTab" :on-tab-click="tabCallback" type="boxed" size="normal">

	                <tab-item :label="$t('COMPLAT-NEWSLETTERS-TAB-NEWSLETTER')">

						<template v-if="!isLoading">

		                    <v-client-table ref="tblComplatNewsletters" name="tblComplatNewsletters" :data="table.tblData" :columns="table.tblColumns" :options="table.tblOptions" class="tbl-complatNewsletters noFirstColumn">

		                        <!-- before table: FILTER OPTIONS -->
		                        <template slot="beforeTable">

									<div class="is-pulled-right">
				                        <div class="columns is-marginless filters">

				                            <div class="column">
												<form-input label="COMPLAT-NEWSLETTER-FILTER-CHANNEL" maxWidth="250px" :showLabel="false" inputType="select" selectFieldName="name" :showLabelInOptions="false" :selectOptions="newsletterTypes" v-model="newsletterTypeSelected" :is-horizontal="true"></form-input>
				                          	</div>

				                            <div class="column">
												<form-input label="COMPLAT-NEWSLETTER-FILTER-STATUS" maxWidth="250px" :showLabel="false" inputType="select" selectFieldName="name" :showLabelInOptions="true" :selectOptions="newsletterStatus" v-model="newsletterStatusSelected" :is-horizontal="true"></form-input>
										    </div>

				                        </div>
				                    </div>

		                        </template>

								<template slot="type" slot-scope="props">
									{{ getLabelName(props.row.channel.name) }}
								</template>

								<template slot="updatedAt" slot-scope="props">
									{{ formatDate(props.row.updatedAt) }}
								</template>

								<template slot="sendDate" slot-scope="props">
									<template v-if="props.row.sendDate != null">
										{{ formatDate2(props.row.sendDate, false) }}
									</template>
								</template>

								<template slot="status" slot-scope="props">
									<template v-if="props.row.status">
										<lang :labelKey="'COMPLAT-NEWSLETTER-STATUS-'+props.row.status.name"></lang>
									</template>
								</template>

								<template slot="subscribers" slot-scope="props">
									{{ props.row.recipientCount }}
								</template>

								<template slot="opens" slot-scope="props">
									{{ round(props.row.openRate * 100, 1) }}%
								</template>

								<template slot="clicks" slot-scope="props">
									{{ round(props.row.clickRate * 100, 1) }}%
								</template>

								<template slot="edit" slot-scope="props">

									<!-- <span class="icon is-small" @click.prevent.stop="newsletterEdit(props.row.id)"><i class="icon-ak-bearbeiten"></i></span> -->
									<template v-if="(props.row.status && props.row.status.name == 'SENT')">
										<span class="icon is-small is-disabled" disabled><i class="icon-ak-entfernen"></i></span>
									</template>

									<template v-else>
										<pop-confirm content="Soll dieser Newsletter wirklich gelöscht werden?" :on-ok="function() { newsletterDelete(props.row.id) }">
											<span class="icon is-small"><i class="icon-ak-entfernen"></i></span>
										</pop-confirm>
									</template>

								</template>

		                    </v-client-table>

						</template>

					</tab-item>


					<!-- RECIPIEINTS -->
					<!-- <tab-item :label="$t('COMPLAT-NEWSLETTERS-TAB-RECIPIENTS')" v-if="['Administrator'].indexOf(userRole) > -1"> -->
					<tab-item :label="$t('COMPLAT-NEWSLETTERS-TAB-RECIPIENTS')" v-if="can('COMPLAT_NEWSLETTER.RECIPIENTS')">

						<template v-if="tabs[activeTab] == 'recipients'">
							<newsletter-recipients :channels="newsletterTypes" :show="tabs[activeTab] == 'recipients'"></newsletter-recipients>
						</template>

					</tab-item>

				</tabs>


            </div>

            <div class="col-aside">

                <custom-button type="blue" name="COMPLAT-NEWSLETTER-BTN-NEWSLETTER_ADD" icon="icon-ak-hinzufuegen" @click.native="newsletterOpenModal"></custom-button>

            </div>

        </div>




        <!-- MODAL -->
		<modal
			:width="modal.width"
			:title="modal.title"
			transition="fadeDown"
			cancel-text="Abbrechen"
			:show-ok="false"
			:backdrop-closable="false"
			:is-show="showModal"
			:class="modal.type"
			@close="closeModal">

				<template v-if="modal.isLoading">

					<loading-indicator></loading-indicator>

				</template>

				<template v-else>

					<!-- NEW NEWSLETTER -->
					<template v-if="modal.type == 'newNewsletter'">

						<div>
							<form-input label="COMPLAT-NEWSLETTER-NEW-CHANNEL" inputType="select" :selectAllowEmpty="false" :selectIsSearchable="false" :selectOptions="newsletterTypes" :showLabel="true" :showLabelInOptions="false" v-model="newsletter.channel" :is-horizontal="false"></form-input>
							<form-input label="COMPLAT-NEWSLETTER-NEW-NAME" inputType="text" :showLabel="true" :showLabelInOptions="false" v-model="newsletter.name" :is-horizontal="false"></form-input>
						</div>

						<div slot="footer">
							<span class="button" @click="closeModal">abbrechen</span>
							<span :class="['button is-success', { 'is-loading': modal.isSaving }]" @click="newsletterAdd">anlegen</span>
						</div>

					</template>

				</template>

		</modal>

    </div>

</template>


<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');
import newsletterRecipients from './incl-newsletterList-recipients';
export default {

    name: 'contentPoolContentOverview',

	components: {
		newsletterRecipients
	},

    data() {

		var self = this;

        return {

            isLoading: false,
            showModal: false,

			newsletterTypeSelected: null,
			newsletterStatusSelected: null,

			newsletterTypes: null,

			activeTab: 0,
			tabs: ['newsletters', 'recipients'],

			newsletter: {
				channel: '',
				name: '',
				subject: '',
				subtitle: '',
				headline: '',
				content: '',
				introText: '',
				sender: '',
			},

			modal: {
				isLoading: false,
				isSaving: false,
				width: '640',
				title: ''
			},

            table: {

				tblColumns: ['name', 'type', 'updatedAt', 'sendDate', 'status', 'subscribers', 'opens', 'clicks', 'edit'],
				tblData: [],
				tblOptions: {
					trackBy: 'id',
                    uniqueKey: 'id',
					saveState: true,
					perPage: 25,
					orderBy: {
						ascending: false,
						column: 'updatedAt'
					},

                    // custom table headings - make them clickable for language Setting
					headings: {

						type(h) {
							return <lang labelKey="COMPLAT-NEWSLETTERS-TBL_HEADER-TYPE"></lang>
						},
						name(h) {
							return <lang labelKey="COMPLAT-NEWSLETTERS-TBL_HEADER-TITLE"></lang>
						},
						updatedAt(h) {
							return <lang labelKey="COMPLAT-NEWSLETTERS-TBL_HEADER-UPDATED"></lang>
						},
						scheduleDate(h) {
							return <lang labelKey="COMPLAT-NEWSLETTERS-TBL_HEADER-SENT"></lang>
						},
						status(h) {
							return <lang labelKey="COMPLAT-NEWSLETTERS-TBL_HEADER-STATUS"></lang>
						},
						subscribers(h) {
							return <lang labelKey="COMPLAT-NEWSLETTERS-TBL_HEADER-SUBSCRIBERS"></lang>
						},
						opens(h) {
							return <lang labelKey="COMPLAT-NEWSLETTERS-TBL_HEADER-OPENS"></lang>
						},
						clicks(h) {
							return <lang labelKey="COMPLAT-NEWSLETTERS-TBL_HEADER-CLICKS"></lang>
						},
						edit(h) {
                            // return <lang labelKey="EQUIPMENTS_TBL_HEADER-DELETE"></lang>
							return 'edit';
                        },
					},

					sortable: ['type', 'name', 'updatedAt', 'sendDate', 'status', 'subscribers', 'opens', 'clicks'],
					sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },

					filterByColumn: false,
					filterable: false,

					texts: {
						filter: 'Filter Ergebnisse:',
						filterPlaceholder: 'Suche',
						limit: 'Einträge pro Seite',
						noResults: 'keine passenden Einträge gefunden',
						count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
					},

					pagination: {
						chunk: 5
					},

					skin: 'table is-striped is-hoverable is-fullwidth',

					// custom filter functions
					customFilters: [
						{
						name: 'filterChannel',
                            callback(row, channel) {

                                if(channel == null || channel == "") {
                                    return true;
                                }

								return channel.id == row.channel.id;

                            }
                        },
						{
						name: 'filterStatus',
                            callback(row, status) {

                                if(status == null || status == "") {
                                    return true;
                                }

								if(row.status && row.status.id && row.status.id == status.id) {
									return true;
								}

								return false;

                            }
                        }
					],

					// custom sorting functions
					customSorting: {

						type: function(ascending) {
							return function (a, b) {
					            return self.sort(a.channel.name, b.channel.name, ascending);
							}
						},

					}

				}
			}

        }

    },

	watch: {

		newsletterTypeSelected(newVal, oldVal) {

            var self = this;
            setTimeout(function() {
                Event.$emit('vue-tables.tblComplatNewsletters.filter::filterChannel', newVal);
            }, 10);

        },

		newsletterStatusSelected(newVal, oldVal) {

	        var self = this;
	        setTimeout(function() {
	            Event.$emit('vue-tables.tblComplatNewsletters.filter::filterStatus', newVal);
	        }, 10);

		}

	},

    created() {

        this.fetchData();

    },

	mounted() {

		Event.$on('vue-tables.tblComplatNewsletters.row-click', function (data) {
			this.newsletterEdit(data.row.id);
		}.bind(this));

	},

	computed: {

		newsletterStatus() {
			return this.$store.getters.getTermsByTaxonomy('NEWSLETTER_STATUS');
		}

	},

    methods: {

		round(value, decimals) {
		  return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
	  },

		tabCallback(index) {

			this.activeTab = index;

		},

		getLabelName(channelName) {

			channelName = (channelName.split(' ').join('_')).toUpperCase();
			return this.$t('CHANNEL-'+ channelName);

		},

		newsletterIsSent(date) {

			if(date == null) {
				return false;
			}

			let d1 = new Date(date);
			let d2 = new Date();

			return (d2 - d1) > 0;

		},


		newsletterEdit(id) {

			this.$router.push({ name: 'complatNewsletter', params: { newsletterID: id }})

		},

		newsletterDelete(id) {

			var self = this;

			let foundIndex = this.table.tblData.findIndex((newsletter) => newsletter.id == id);
			this.axios.delete(this.$config.api + 'newsletter/'+id).then(response => {
				self.table.tblData.splice(foundIndex, 1);
				self.$notify.open({ content: 'Newsletter wurde erfolgreich gelöscht!', type: 'success'} );
			})

		},


		newsletterOpenModal() {

			this.modal.title = "Newsletter anlegen";
			this.modal.type = "newNewsletter";
            this.showModal = true;

		},

        newsletterAdd() {

			if(this.newsletter.name == "") {
				this.$notify.open({ content: 'Bitte vergeben Sie einen internen Titel!', type: 'warning'})
				return;
			}
			if(this.newsletter.channel == "") {
				this.$notify.open({ content: 'Bitte wählen Sie einen Typ aus!', type: 'warning'})
				return;
			}

			this.newsletter.status = this.newsletterStatus.DRAFT;
			this.newsletter.subject = this.newsletter.channel.data.subject || '';

			this.modal.isSaving = true;

			// make DB entry, fetch new ID -> redirect to input mask
			var self = this;

			this.entityCreateOrUpdate('newsletter', this.newsletter)
				.then((response) => {
					self.modal.isSaving = false;
					self.$router.push({ name: 'complatNewsletter', params: { newsletterID: response.id }})
				})

        },

        closeModal() {

            this.showModal = false;
            this.modal.title = "";
			this.modal.type = "";

        },

        fetchData() {

			this.isLoading = true;
			var self = this;

			function newsletterTypes() {
				// return self.axios.get(self.$config.api + 'channel?include=channel.type&filters[type.name]=NEWSLETTER&orderBy=name');
				// return self.axios.get(self.$config.api + 'channel?include=channel.type&filters[type.name]=NEWSLETTER&filters[id]=7,8,9,13,14,15,16&orderBy=name');
				return self.axios.get(self.$config.api + 'channel?include=channel.type&filters[type.name]=NEWSLETTER&filters[isCommunicationPlatformNewsletter]=1&orderBy=name');

			}
			function newsletters() {
				// return self.axios.get(self.$config.api + 'newsletter?include=newsletter.channel,newsletter.status&filters[channel]=7,8,9,13,14,15,16');
				return self.axios.get(self.$config.api + 'newsletter?include=newsletter.channel,newsletter.status&filters[channel.isCommunicationPlatformNewsletter]=1');

			}

			this.axios.all([newsletterTypes(), newsletters()])
				.then(self.axios.spread(function (newsletterTypes, newsletters) {

					self.newsletterTypes = newsletterTypes.data.channel;
					self.table.tblData = newsletters.data.newsletter;
                    self.isLoading = false;

				})).catch(function(error) {
					console.log("ERROR: ", error);
				});

        }

    }

}
</script>




<style>

	.newNewsletter .modal-card-body {
		display: flex;
		justify-content: center;
	}
	.newNewsletter .singleSelect {
    	min-width: 420px !important;
	}
	.newNewsletter .modal-card-body .control {
		max-width: 100% !important;
	}
	.is-disabled {
		color: #ddd;
		cursor: not-allowed;
	}
</style>

<style lang="scss">

	.tbl-complatNewsletters {

		.VueTables__table {

			tr {

				th {
					&:last-child {
						text-align: center;
					}
				}

				td {

					&:last-child {
						text-align: center;
					}

					.icon {
						margin: 3px 0 0 0;
					}
				}
			}
		}

	}
</style>
